<template>
  <div class="data-overview-page">
    <div class="page-header">
      <div class="header-left">
        <h2 class="page-title"><i class="el-icon-data-analysis"></i> 数据概览</h2>
        <span class="page-desc">查看平台整体经营数据及关键指标趋势</span>
      </div>
    </div>
    <!-- 顶部筛选栏 -->
    <div class="filter-bar">
      <div class="filter-left">
        <el-radio-group v-model="timeType" size="small" @change="onTimeTypeChange">
          <el-radio-button :label="0">今日</el-radio-button>
          <el-radio-button :label="1">昨日</el-radio-button>
          <el-radio-button :label="2">近7天</el-radio-button>
          <el-radio-button :label="3">近30天</el-radio-button>
          <el-radio-button :label="4">近半年</el-radio-button>
          <el-radio-button :label="5">近一年</el-radio-button>
        </el-radio-group>
      </div>
      <div class="filter-right">
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="loadData" :loading="loading">刷新数据</el-button>
      </div>
    </div>

    <!-- 经营概览 -->
    <div class="section-title"><i class="el-icon-data-analysis"></i> 经营概览</div>
    <div class="overview-cards">
      <div class="ov-card">
        <div class="ov-card-icon" style="background: linear-gradient(135deg,#409EFF,#66B1FF)">
          <i class="el-icon-document"></i>
        </div>
        <div class="ov-card-info">
          <div class="ov-card-value">{{ formatNumber(overview.totalOrders) }}</div>
          <div class="ov-card-label">总订单数</div>
        </div>
      </div>
      <div class="ov-card">
        <div class="ov-card-icon" style="background: linear-gradient(135deg,#67C23A,#85CE61)">
          <i class="el-icon-money"></i>
        </div>
        <div class="ov-card-info">
          <div class="ov-card-value">¥{{ formatMoney(overview.totalRevenue) }}</div>
          <div class="ov-card-label">总营收</div>
        </div>
      </div>
      <div class="ov-card">
        <div class="ov-card-icon" style="background: linear-gradient(135deg,#E6A23C,#EBB563)">
          <i class="el-icon-truck"></i>
        </div>
        <div class="ov-card-info">
          <div class="ov-card-value">{{ formatNumber(overview.onlineVehicles) }}</div>
          <div class="ov-card-label">在线车辆 / 共{{ overview.totalVehicles || 0 }}辆</div>
        </div>
      </div>
      <div class="ov-card">
        <div class="ov-card-icon" style="background: linear-gradient(135deg,#909399,#A6A9AD)">
          <i class="el-icon-user"></i>
        </div>
        <div class="ov-card-info">
          <div class="ov-card-value">{{ formatNumber(overview.onlineDrivers) }}</div>
          <div class="ov-card-label">在线司机 / 共{{ overview.totalDrivers || 0 }}人</div>
        </div>
      </div>
    </div>

    <!-- 图表区域 3列 -->
    <div class="charts-grid">
      <div class="chart-card" style="grid-column: span 2;">
        <div class="chart-card-header">
          <span><i class="el-icon-data-line"></i> 订单趋势分析</span>
          <el-radio-group v-model="orderTimeType" size="mini" @change="loadOrderTrend">
            <el-radio-button :label="0">今日</el-radio-button>
            <el-radio-button :label="1">昨日</el-radio-button>
            <el-radio-button :label="7">近7天</el-radio-button>
            <el-radio-button :label="30">近30天</el-radio-button>
            <el-radio-button :label="180">近半年</el-radio-button>
            <el-radio-button :label="365">近一年</el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-body" ref="orderTrendChart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-card-header"><span><i class="el-icon-pie-chart"></i> 订单状态分布</span></div>
        <div class="chart-body" ref="orderStatusChart"></div>
      </div>
    </div>

    <!-- 底部 2列 -->
    <div class="charts-grid-half">
      <div class="chart-card">
        <div class="chart-card-header">
          <span><i class="el-icon-coin"></i> 营收趋势</span>
          <el-radio-group v-model="revenueTimeType" size="mini" @change="loadRevenueTrend">
            <el-radio-button :label="0">今日</el-radio-button>
            <el-radio-button :label="1">昨日</el-radio-button>
            <el-radio-button :label="7">近7天</el-radio-button>
            <el-radio-button :label="30">近30天</el-radio-button>
            <el-radio-button :label="180">近半年</el-radio-button>
            <el-radio-button :label="365">近一年</el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-body" ref="revenueTrendChart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-card-header">
          <span><i class="el-icon-s-data"></i> 热门线路 TOP5</span>
          <el-radio-group v-model="lineRankTimeType" size="mini" @change="loadLineRank">
            <el-radio-button :label="0">今日</el-radio-button>
            <el-radio-button :label="1">昨日</el-radio-button>
            <el-radio-button :label="2">近7天</el-radio-button>
            <el-radio-button :label="3">近30天</el-radio-button>
            <el-radio-button :label="4">近半年</el-radio-button>
            <el-radio-button :label="5">近一年</el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-body" ref="lineRankChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "DataOverview",
  data() {
    return {
      loading: false,
      timeType: 0,
      overview: {
        totalOrders: 0,
        orderTrend: 0,
        totalRevenue: 0,
        revenueTrend: 0,
        onlineVehicles: 0,
        totalVehicles: 0,
        onlineDrivers: 0,
        totalDrivers: 0
      },
      orderTimeType: 0,
      revenueTimeType: 0,
      lineRankTimeType: 0,
      charts: {},
      resizeHandler: null
    };
  },
  mounted() {
    this.loadData();
    this.resizeHandler = () => {
      Object.values(this.charts).forEach(chart => chart && chart.resize());
    };
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    if (this.resizeHandler) window.removeEventListener("resize", this.resizeHandler);
    Object.values(this.charts).forEach(chart => chart && chart.dispose());
  },
  methods: {
    formatNumber(num) {
      if (!num) return "0";
      return num.toLocaleString();
    },
    formatMoney(num) {
      if (!num) return "0.00";
      return parseFloat(num).toLocaleString("zh-CN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    async loadData() {
      this.loading = true;
      await Promise.all([
        this.loadOverview(),
        this.loadOrderTrend(),
        this.loadOrderStatus(),
        this.loadLineRank(),
        this.loadRevenueTrend()
      ]);
      this.loading = false;
      this.$nextTick(() => { setTimeout(() => this.handleResize(), 200); });
    },
    handleResize() {
      Object.values(this.charts).forEach(chart => chart && chart.resize());
    },
    onTimeTypeChange() {
      this.loadData();
    },
    async loadOverview() {
      try {
        const res = await this.$axios.get("/api/v1/manage/statistics");
        if (res && res.code === 1) {
          const data = res.data || {};
          this.overview = {
            totalOrders: data.orderCreatNum || 0,
            orderTrend: data.orderTrend || 0,
            totalRevenue: data.orderPayAmount || 0,
            revenueTrend: data.revenueTrend || 0,
            onlineVehicles: data.vehicleOnlineNum || 0,
            totalVehicles: data.vehicleNum || 0,
            onlineDrivers: data.driverOnlineNum || 0,
            totalDrivers: data.driverNum || 0
          };
        }
      } catch (e) {
        console.error("加载概览数据失败", e);
      }
    },
    async loadOrderTrend() {
      try {
        const ttMap = { 0: '0', 1: '1', 7: '2', 30: '3', 180: '4', 365: '5' };
        const res = await this.$axios.get("/api/v1/manage/statistics/report", {
          timeType: ttMap[this.orderTimeType] || '0'
        });
        if (res && res.code === 1) {
          const list = res.data?.statisticsReportVos || [];
          this.renderOrderTrendChart(list);
        }
      } catch (e) {
        console.error("加载订单趋势失败", e);
        this.renderOrderTrendChart([]);
      }
    },
    async loadOrderStatus() {
      try {
        const res = await this.$axios.get("/api/v1/manage/statistics/dataBriefing", {
          timeType: "2"
        });
        if (res && res.code === 1) {
          this.renderOrderStatusChart(res.data || {});
        }
      } catch (e) {
        console.error("加载订单状态失败", e);
        this.renderOrderStatusChart({});
      }
    },
    async loadLineRank() {
      try {
        const res = await this.$axios.get("/api/v1/manage/analysis/line", {
          timeType: this.lineRankTimeType
        });
        const list = (res?.data || []).sort((a, b) => (b.orderCount || 0) - (a.orderCount || 0)).slice(0, 5);
        this.renderLineRankChart(list);
      } catch (e) {
        console.error("加载线路排行失败", e);
        this.renderLineRankChart([]);
      }
    },
    async loadRevenueTrend() {
      try {
        const ttMap = { 0: '0', 1: '1', 7: '2', 30: '3', 180: '4', 365: '5' };
        const res = await this.$axios.get("/api/v1/manage/statistics/report", {
          timeType: ttMap[this.revenueTimeType] || '0'
        });
        if (res && res.code === 1) {
          const list = res.data?.statisticsReportVos || [];
          this.renderRevenueTrendChart(list);
        }
      } catch (e) {
        console.error("加载营收趋势失败", e);
        this.renderRevenueTrendChart([]);
      }
    },
    initChart(refName) {
      if (this.charts[refName]) this.charts[refName].dispose();
      const dom = this.$refs[refName];
      if (!dom) return null;
      const chart = echarts.init(dom);
      this.charts[refName] = chart;
      return chart;
    },
    renderOrderTrendChart(data) {
      const xData = data.map(item => {
        let time = item.time || "";
        if (time.includes(" ")) time = time.split(" ")[0];
        if (time.length === 10) time = time.substring(5);
        return time;
      });
      const createData = data.map(item => item.orderCreateNum || 0);
      const finishData = data.map(item => item.orderFinishNum || 0);

      const option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(50, 50, 50, 0.9)",
          borderColor: "#333",
          textStyle: { color: "#fff" }
        },
        legend: {
          data: ["创建订单", "完成订单"],
          bottom: 0,
          textStyle: { color: "#666" }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "15%",
          top: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xData,
          axisLine: { lineStyle: { color: "#ddd" } },
          axisLabel: { color: "#666" }
        },
        yAxis: {
          type: "value",
          axisLine: { show: false },
          splitLine: { lineStyle: { color: "#f0f0f0" } },
          axisLabel: { color: "#666" }
        },
        series: [
          {
            name: "创建订单",
            type: "line",
            smooth: true,
            data: createData,
            itemStyle: { color: "#409EFF" },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(64, 158, 255, 0.3)" },
                { offset: 1, color: "rgba(64, 158, 255, 0.05)" }
              ])
            }
          },
          {
            name: "完成订单",
            type: "line",
            smooth: true,
            data: finishData,
            itemStyle: { color: "#67C23A" },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(103, 194, 58, 0.3)" },
                { offset: 1, color: "rgba(103, 194, 58, 0.05)" }
              ])
            }
          }
        ]
      };
      const c = this.initChart('orderTrendChart'); c && c.setOption(option);
    },
    renderOrderStatusChart(data) {
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          right: "5%",
          top: "center",
          textStyle: { color: "#666" }
        },
        series: [
          {
            type: "pie",
            radius: ["45%", "70%"],
            center: ["35%", "50%"],
            avoidLabelOverlap: false,
            label: { show: false },
            emphasis: {
              label: { show: true, fontSize: 14, fontWeight: "bold" }
            },
            data: [
              { value: data.orderFinishNum || 0, name: "已完成", itemStyle: { color: "#67C23A" } },
              { value: data.orderPayNum || 0, name: "待出行", itemStyle: { color: "#409EFF" } },
              { value: data.orderUnpaidNum || 0, name: "待支付", itemStyle: { color: "#E6A23C" } },
              { value: data.orderRefundNum || 0, name: "已退票", itemStyle: { color: "#F56C6C" } }
            ]
          }
        ]
      };
      const c = this.initChart('orderStatusChart'); c && c.setOption(option);
    },
    renderLineRankChart(data) {
      const lineData = Array.isArray(data) ? data : [];
      // reverse() 是原地操作，需要先 slice() 复制避免影响原数组
      const names = lineData.map(item => item.lineName || "").slice().reverse();
      const values = lineData.map(item => item.orderCount || 0).slice().reverse();

      const isEmpty = lineData.length === 0;
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" }
        },
        grid: {
          left: "3%",
          right: "10%",
          bottom: "3%",
          top: isEmpty ? "10%" : "3%",
          containLabel: true
        },
        graphic: isEmpty ? [{
          type: "text",
          left: "center",
          top: "middle",
          style: { text: "暂无数据", fill: "#c0c4cc", fontSize: 14 }
        }] : [],
        xAxis: {
          type: "value",
          axisLine: { show: false },
          splitLine: { lineStyle: { color: "#f0f0f0" } },
          axisLabel: { color: "#666" }
        },
        yAxis: {
          type: "category",
          data: names,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: "#666" }
        },
        series: [
          {
            type: "bar",
            data: values,
            barWidth: 16,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: "#409EFF" },
                { offset: 1, color: "#66B1FF" }
              ]),
              borderRadius: [0, 8, 8, 0]
            },
            label: {
              show: true,
              position: "right",
              color: "#666",
              formatter: "{c}"
            }
          }
        ]
      };
      const c = this.initChart('lineRankChart'); c && c.setOption(option);
    },
    renderRevenueTrendChart(data) {
      const xData = data.map(item => {
        let time = item.time || "";
        if (time.includes(" ")) time = time.split(" ")[0];
        if (time.length === 10) time = time.substring(5);
        return time;
      });
      const revenueData = data.map(item => item.orderPayAmount || 0);

      const option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(50, 50, 50, 0.9)",
          formatter: params => {
            const p = params[0];
            return `${p.name}<br/>${p.seriesName}: ¥${p.value.toLocaleString()}`;
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          top: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLine: { lineStyle: { color: "#ddd" } },
          axisLabel: { color: "#666" }
        },
        yAxis: {
          type: "value",
          axisLine: { show: false },
          splitLine: { lineStyle: { color: "#f0f0f0" } },
          axisLabel: {
            color: "#666",
            formatter: value => (value >= 10000 ? (value / 10000) + "万" : value)
          }
        },
        series: [
          {
            name: "营收",
            type: "bar",
            data: revenueData,
            barWidth: 20,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#67C23A" },
                { offset: 1, color: "#85CE61" }
              ]),
              borderRadius: [4, 4, 0, 0]
            }
          }
        ]
      };
      const c = this.initChart('revenueTrendChart'); c && c.setOption(option);
    }
  }
};
</script>

<style lang="less" scoped>
.data-overview-page {
  padding: 20px;
  background: #f5f7fa;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;

  .filter-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 16px 20px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    margin-bottom: 20px;
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    i { margin-right: 8px; color: #409EFF; }
  }

  .overview-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    margin-bottom: 24px;

    .ov-card {
      background: #fff;
      border-radius: 10px;
      padding: 16px;
      display: flex;
      align-items: center;
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      transition: all 0.2s ease;
      &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0,0,0,0.1); }

      .ov-card-icon {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        flex-shrink: 0;
        i { color: #fff; font-size: 18px; }
      }

      .ov-card-info {
        min-width: 0;
        .ov-card-value {
          font-size: 20px;
          font-weight: 700;
          color: #303133;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .ov-card-label { font-size: 12px; color: #909399; margin-top: 2px; }
      }
    }
  }

  .chart-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    overflow: hidden;
    min-width: 0;

    .chart-card-header {
      padding: 14px 20px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 14px;
      font-weight: 600;
      color: #303133;
      display: flex;
      align-items: center;
      justify-content: space-between;
      i { margin-right: 6px; color: #409EFF; }
    }

    .chart-body {
      width: 100%;
      height: 320px;
      padding: 10px;
      box-sizing: border-box;
    }
  }

  .charts-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 20px;
  }

  .charts-grid-half {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 24px;
  }

  @media (max-width: 1400px) {
    .overview-cards { grid-template-columns: repeat(2, 1fr); }
    .charts-grid { grid-template-columns: repeat(2, 1fr); }
  }
  @media (max-width: 1000px) {
    .overview-cards { grid-template-columns: 1fr; }
    .charts-grid, .charts-grid-half { grid-template-columns: 1fr; }
  }
}
</style>
